var Forfaits = {  
  "Forfait Compétition": "https://calendly.com/contact-5918/competition",
  "Forfait Découverte": "https://calendly.com/contact-5918/decouverte",
  "Forfait Détermination solo 1 mois": "https://calendly.com/contact-5918/determination-option1mois",
  "Forfait Détermination solo 3 mois": "https://calendly.com/contact-5918/determination-option3mois",
  "Forfait Détermination solo 6 mois": "https://calendly.com/contact-5918/determination-option6mois",
  "Forfait Détermination couple 1 mois": "https://calendly.com/contact-5918/determinationcouple-option1mois",
  "Forfait Détermination couple 3 mois": "https://calendly.com/contact-5918/determinationcouple-option3mois",
  "Forfait Détermination couple 6 mois": "https://calendly.com/contact-5918/determinationcouple-option6mois",
  "Forfait Entre Amis": "https://calendly.com/contact-5918/concultation-entre-amis",
  "Forfait Performance 1 mois": "https://calendly.com/contact-5918/performance-option1mois",
  "Forfait Performance 3 mois": "https://calendly.com/contact-5918/performance-option3mois",
  "Forfait Performance 6 mois": "https://calendly.com/contact-5918/performance-option6mois",

  "Suivi solo": "https://calendly.com/contact-5918/consultation-suivi",
  "Suivi couple": "https://calendly.com/contact-5918/consultation-couple-suivi",
  "Suivi étudiant": "https://calendly.com/contact-5918/consultation-suivi-etudiant",
  "1ere consultation solo": "https://calendly.com/contact-5918/1ere-consultation",  
  "1ere consultation couple": "https://calendly.com/contact-5918/1ere-consultation-couple",
  "1ere consultation étudiant": "https://calendly.com/contact-5918/1ere-consultation-etudiant",
  "1er mois solo": "https://calendly.com/contact-5918/forfait-1er-mois",
  "1er mois couple": "https://calendly.com/contact-5918/forfait-1er-mois-couple",
  "1er mois étudiant": "https://calendly.com/contact-5918/forfait-1er-mois-etudiant",
  "Mois supplémentaire solo": "https://calendly.com/contact-5918/forfait-mois-supplementaire",
  "Mois supplémentaire couple": "https://calendly.com/contact-5918/forfait-mois-supplementaire-couple",
  "Mois supplémentaire étudiant": "https://calendly.com/contact-5918/forfait-mois-supplementaire-etudiant"
}

function getSelectedOptions(sectionId){
  
  variants = document.querySelectorAll("variant-radios[data-section="+sectionId+"] input:checked")
  options=""
  variants.forEach(function(variant) {
    options += " " + variant.value
  })
  return options
}

function changeButtonUrlIfForfait(productType, title, id) {
  console.log("KRISSSS")
  console.log(productType)
  console.log("KRISSSS")
  if (productType == 'Forfait') {
    changeButtonUrl(title, id);
  }
}

function changeButtonUrl(productName, sectionId){
  options = getSelectedOptions(sectionId)
  document.querySelectorAll("a#"+sectionId)[0].innerHTML = "Prendre RDV pour " + options;
  document.querySelectorAll("a#"+sectionId)[0].href = Forfaits[productName + options];  
}

function initButton(productName, sectionId){
    var aTag = document.querySelectorAll("a#" + sectionId)[0]
    options = getSelectedOptions(sectionId)
    if (options.includes("Default Title")){
      aTag.href  = Forfaits[productName]
    }else{
      aTag.href  = Forfaits[productName + options] 
    }
}

function initButtonWithOption(productName, sectionId, option){
  option_list =  option.split(" / ")
  options=""
  option_list.forEach((option)=> {
    options += " " + option
  })
  if (option == "-Default Title"){
    document.querySelectorAll("a#"+sectionId)[0].href = Forfaits[productName];  
  }else{
    document.querySelectorAll("a#"+sectionId)[0].href = Forfaits[productName + options];   
  }
}